<template>
  <a-layout-sider :class="[theme, 'sider', isMobile ? null : 'shadow', fixSiderbar? 'ant-fixed-sidemenu' : null]"
                  width="256px"
                  :collapsible="collapsible"
                  v-model="collapsed"
                  :trigger="null">
    <div :class="['logo',{min:collapsed}, theme]">
      <!-- <router-link to="/">
        <img :src="systemIcon" alt />
        <span :class="['sys-title','animated','fadeIn',{isShow:collapsed}]">{{systemName}}</span>
      </router-link> -->
    </div>
    <menu-bar :theme="theme"
              :collapsed="collapsed"
              :menuData="menuData"
              @select="onSelect" />
    <!-- <div class="bigScreenData" @click="onBigScreen">大屏展示</div> -->
    <!-- <router-link :to="{path:'/bigscreen'}"
                 class="bigScreenData">大屏展示</router-link> -->
    <!-- <i-menu :theme="theme" :collapsed="collapsed" :menuData="menuData" @select="onSelect"/> -->
    <a-icon v-if="layout === 'side'"
            class="trigger"
            :style="{color:theme == 'light'?'black':'white'}"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="toggleCollapse" />
  </a-layout-sider>
</template>

<script>
// import IMenu from './menu'
import MenuBar from "./MenuBar";
import { mapState } from "vuex";

export default {
  name: "SiderMenu",
  components: {
    // IMenu,
    MenuBar,
  },
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    menuData: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: "dark",
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.setting.isMobile,
      systemName: (state) => state.setting.systemName,
      fixSiderbar: (state) => state.setting.fixSiderbar,
      systemIcon: (state) => state.setting.systemIcon,
      layout: (state) => state.setting.layout,
    }),
    logoIcon() {
      // return this.theme == 'light'?require('../../../static/img/ranqi_logo_red.png'):require('../../../static/img/logo1.png')
      return this.$db.get("titleImg");
    },
  },
  methods: {
    onSelect(obj) {
      this.$emit("menuSelect", obj);
    },
    toggleCollapse() {
      this.$store.commit("business/toggleCollapse", new Date());
      this.$emit("toggleCollapse");
    },
    /* onBigScreen() {
      this.$router.push('/bigscreen')
    }, */
  },
};
</script>

<style lang="less" scoped>
.trigger {
  display: block;
  margin: 0 auto;
  font-size: 20px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
  color: #fff;
}
// .bigScreenData {
//   display: block;
//   margin: 0 auto;
//   width: 100px;
//   height: 43px;
//   text-align: center;
//   line-height: 43px;
//   font-size: 14px;
//   color: rgba(255, 255, 255, 0.647058823529412);
//   border: rgba(153, 153, 153, 1) 2px solid;
//   border-radius: 10px;
//   font-family: "Arial Normal", "Arial";
//   font-weight: 400;
//   font-style: normal;
//   &:hover {
//     cursor: pointer;
//   }
// }

.isShow {
  visibility: hidden;
}
.shadow {
  box-shadow: 1px 0 6px rgba(0, 21, 41, 0.35);
}
.sider {
  z-index: 16;
  position: relative;
  padding-bottom: 120px;
  overflow-x: hidden;
  &.light {
    background-color: #fff;
  }
  &.dark {
    background-color: #393e46;
    // background-color: #39fdd3;
  }
  &.ant-fixed-sidemenu {
    position: fixed;
    overflow-y: auto;
    height: 100%;
  }
  .logo {
    height: 59px;
    position: relative;
    line-height: 59px;
    padding-left: 18px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    overflow: hidden;
    &.min {
      padding-left: 24px;
    }
    &.light {
      // background-color: #fff;
      background-color: #004290;
      // border-bottom: 1px solid #f8f8f8;
      .sys-title {
        color: #fff;
      }
    }
    &.dark {
      background-color: #393e46;
      .sys-title {
        color: #fff;
      }
    }
    .sys-title {
      color: #fff;
      font-size: 18px;
      margin: 0 0 0 0px;
      font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
        PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue,
        Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji,
        Segoe UI Symbol;
      font-weight: 600;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      vertical-align: middle;
    }
    img {
      width: 32px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu/SiderMenu.vue